/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.FameAdvantage {
    angular.module('meevo.plugins.fameAdvantage', []);
}
